// Meeting links are free-typed, and users routinely paste them without a scheme
// ("meet.google.com/abc-defg-hij"). A scheme-less value is treated as a *relative* URL by the browser
// (so a Join link resolves against the current app path) and is rejected by recall.ai, so we normalize
// to an absolute https:// URL before saving and before rendering any href.
export function normalizeMeetingUrl(url: string | null | undefined): string {
  const trimmed = (url ?? '').trim()
  if (!trimmed) return ''
  // Keep well-formed http(s) URLs as-is.
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  // Protocol-relative ("//host/..."): force https.
  if (trimmed.startsWith('//')) return `https:${trimmed}`
  // Anything else (a bare host/path, or a non-http scheme like javascript:/data:) is treated as an
  // https host. Prefixing https:// also neutralizes attempts to smuggle a dangerous scheme into an href.
  return `https://${trimmed}`
}
